import { GenericDomainError } from '../../../types/errors/generic-domain-error';
export class GiftCardDomainError extends GenericDomainError {
    // TODO: Investigate a way to simplify domain error handling. #286495
    constructor(errorCode, errorCodeDescription, errorData, ...params) {
        super(errorCode, errorCodeDescription, errorData, ...params);
        this.errorCode = errorCode;
        this.errorCodeDescription = errorCodeDescription;
        this.errorData = errorData;
        Object.setPrototypeOf(this, GiftCardDomainError.prototype);
    }
}
export var GiftCardDomainSpecificErrorCode;
(function (GiftCardDomainSpecificErrorCode) {
    GiftCardDomainSpecificErrorCode[GiftCardDomainSpecificErrorCode["GiftCardCredentialsInvalid"] = 100] = "GiftCardCredentialsInvalid";
})(GiftCardDomainSpecificErrorCode || (GiftCardDomainSpecificErrorCode = {}));
